import { MARQUEE_ITEMS } from '../data/site';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className="fm-marquee relative overflow-hidden border-y border-white/10 bg-navy-deep py-5"
      data-testid="services-marquee"
      aria-hidden="true"
    >
      <div className="fm-marquee-track flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-display text-sm font-semibold uppercase tracking-[0.3em] text-slate-300">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
}
